import { Dialog, DialogPanel, DialogBackdrop, Transition, TransitionChild } from '@headlessui/react'

interface BottomSheetProps {
  isOpen: boolean
  onClose: () => void
  onAfterLeave?: () => void
  children: React.ReactNode
}

export default function BottomSheet({
  isOpen,
  onClose,
  onAfterLeave,
  children,
}: BottomSheetProps) {
  return (
    <Transition appear show={isOpen} afterLeave={onAfterLeave}>
      <Dialog onClose={() => {}} className="relative z-50">
        <TransitionChild
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <DialogBackdrop className="fixed inset-0 bg-[var(--overlay-backdrop)] backdrop-blur-[2px]" />
        </TransitionChild>

        <div className="fixed inset-0 flex items-end justify-center">
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="translate-y-full"
            enterTo="translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="translate-y-0"
            leaveTo="translate-y-full"
          >
            <DialogPanel className="w-full max-h-[92dvh] very-short:max-h-[85dvh] flex flex-col bg-[var(--surface-card)] rounded-t-2xl shadow-[var(--shadow-elevated)] sm:max-w-lg sm:max-h-[85dvh]">
              {children}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}
